import { render } from "./LoadingFull.vue?vue&type=template&id=6fd458f0&scoped=true"
const script = {}

import "./LoadingFull.vue?vue&type=style&index=0&id=6fd458f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd458f0"]])

export default __exports__